<template>
  <div style="width: 100%;">
    <BaseIndex
      ref="baseIndex"
      :modelNameSingular="modelNameSingular"
      :modelNamePlural="modelNamePlural"
      :pageLoading="pageLoading"
      :loading="loading"
      :table-headers="tableHeaders"
      :table-items="indexItems"
      :maskFields="maskFields"
      :infoHeaders="infoHeaders"
      @options-change="optionsChange"
      :serverItemsLength="totalItems"
      :loadOptions="options"
      :enableCustomFilters="true"
      :containTopToolbar="false"
      :typeOperators="typeOperators"
      :serverFields="serverFields"
      @filter-confirm-action="applyFilters"
    >

      <template slot="new" v-if="$can('create', $router.currentRoute.name)">
        <New
          @entry-created="entryCreated"
          :isCustomer="true"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
        <Edit
          :entry="item"
          :readOnly="true"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
        <Edit
          :entry="item"
          @entry-updated="entryUpdated"
          :modelNameSingular="modelNameSingular"
          :isEdit="true"
        />
      </template>

      <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
        <Delete
          :entry="item"
          @entry-destroyed="entryDeleted"
          :modelNameSingular="modelNameSingular"
        />
      </template>

      <template slot="action4" slot-scope="{ item }">
       <AgendaIndex :person="item"
      />
    </template>

    </BaseIndex>

  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import BasePrint from "@shared_components/base_print.vue";
import AgendaIndex from "@models/agendas/index_for_person.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: true,
      pageLoading: false,
      loggedUser: null,
      accountPermissions: null,
      totalItems: 0,
      // tableHeaders: [],//createHeader(),
      maskFields: [
        { field: 'types', mask: 'tag', color: 'success', outlined: true }, 
        { field: 'colorWithText', mask: 'color_with_text'},
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Pessoa"
    },
    modelNamePlural: {
      type: String,
      default: "Pessoas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePrint: BasePrint,
    AgendaIndex: AgendaIndex
  },
  beforeMount(){
    console.log("bmounted");
  },
  mounted(){
    console.log("mounted");
  },
  async created(){
    await this.getCurrentUser(user => {
      this.loggedUser = user;
    });
    // this.loading = false;
    // this.loadServerEntries();

    // this.applyFilters(this.filters);
  },
  computed: {
    tableHeaders(){
      var result = null;
      console.log("com");
      if( this.loggedUser && this.loggedUser.isAltavenda){
        result = [
          { text: "Código", align: "left", sortable: true, value: "code" },
          { text: "Etiqueta", align: "left", sortable: false, value: "colorWithText" },
          { text: "Nome/Razão Social", align: "left", sortable: true, value: "name" },
        // { text: "Apelido/Nome Fantasia", align: "left", sortable: true, value: "" },
          { text: "CPF/CNPJ", align: "left", sortable: true, value: "document" },        
          { text: "Telefone", align: "left", sortable: true, value: "phone" },
          { text: "E-mail", align: "left", sortable: true, value: "email" },
          // { text: "Parceiro Comercial", align: "left", sortable: true, value: "companyName" },
          { text: "Cidade", align: "left", sortable: true, value: "cities" },
          { text: "Rotas", align: "left", sortable: true, value: "routeNames" },
          { text: "Tipo", align: "left", sortable: true, value: "types" , filter_value: "type"},
          { text: "Ações", align: "left", sortable: false, value: "action" }
        ];
      }else{
        result = [
          { text: "Código", align: "left", sortable: true, value: "code" },
          { text: "Etiqueta", align: "left", sortable: false, value: "colorWithText" },
          { text: "Nome/Razão Social", align: "left", sortable: true, value: "name" },
        // { text: "Apelido/Nome Fantasia", align: "left", sortable: true, value: "" },
          { text: "CPF/CNPJ", align: "left", sortable: true, value: "document" },        
          { text: "Telefone", align: "left", sortable: true, value: "phone" },
          { text: "E-mail", align: "left", sortable: true, value: "email" },
          // { text: "Parceiro Comercial", align: "left", sortable: true, value: "companyName", not_show: true },
          { text: "Cidade", align: "left", sortable: true, value: "cities" },
          { text: "Rotas", align: "left", sortable: true, value: "routeNames" },
          { text: "Tipo", align: "left", sortable: true, value: "types" , filter_value: "type"},
          { text: "Ações", align: "left", sortable: false, value: "action" }
        ];
      }
      return result;
    }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_PEOPLE,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.people = response.data.accountContext.allPeople;
          this.indexItems = response.data.accountContext.peopleIndex.personViewIndexFilters; //seta os itens retornados do servidor para o array de itens que será exibido na tabela
          this.totalItems = response.data.accountContext.peopleIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.peopleIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.peopleIndex.serverFields; // seta os campos que podem ser filtrados

          console.log("indexItems", this.indexItems);
          for(var person in this.indexItems) {
            this.indexItems[person].types = [];
            if ((this.indexItems[person].type & COLLABORATOR) == COLLABORATOR) {
              this.indexItems[person].types.push("Colaborador");
            }
            if ((this.indexItems[person].type & CUSTOMER) == CUSTOMER) {
              this.indexItems[person].types.push("Cliente");
            }
            if ((this.indexItems[person].type & SUPPLIER) == SUPPLIER) {
              this.indexItems[person].types.push("Fornecedor");
            }
            if ((this.indexItems[person].type & CARRIER) == CARRIER) {
              this.indexItems[person].types.push("Transportadora");
            }
            if ((this.indexItems[person].type & EMPLOYEE) == EMPLOYEE) {
              this.indexItems[person].types.push("Funcionário");
            }
            if ((this.indexItems[person].type & DRIVER) == DRIVER) {
              this.indexItems[person].types.push("Motorista");
            }
          }
          // console.log("All people", this.people);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
  }
};

const LOAD_ALL_PEOPLE = gql `
  query($input: IndexInputObject!) {
    accountContext {
      peopleIndex(input: $input){
        count
        typeOperators
        serverFields      
        personViewIndexFilters {
          id
          code
          kind
          document                           
          name
          colorWithText
          type
          email
          phone
          companyName
          cities
          routeNames     
          canBeDeleted
          undeletabilityReasons
        }
      }
      accountPermissions{
        isAltavenda
      }
    }
  }
`;

const CUSTOMER = 1;
const COLLABORATOR = 2;
const SUPPLIER = 4;
const EMPLOYEE = 8;
const CARRIER = 16;
const DRIVER = 32;

</script>

<style scoped></style>
